import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addErrorToReport as addErrorReportThunk } from '@americanexpress/one-app-ducks';
import { getLocaleData } from '@/selectors/localeSelectors';

class ErrorReporter extends Component {
  constructor() {
    super();
    this.handleOnError = this.handleOnError.bind(this);
    this.handleUnhandledRejection = this.handleUnhandledRejection.bind(this);
  }

  componentDidMount() {
    // onerror is an older browser API, addEventListener isn't quite the same
    window.addEventListener('error', this.handleOnError);
    window.addEventListener(
      'unhandledrejection',
      this.handleUnhandledRejection
    );
  }

  componentDidCatch(error) {
    const { addErrorToReport } = this.props;
    addErrorToReport(error);
  }

  componentWillUnmount() {
    // onerror is an older browser API, addEventListener isn't quite the same
    window.addEventListener('error', null);
    window.removeEventListener(
      'unhandledrejection',
      this.handleUnhandledRejection
    );
  }

  handleOnError(errorEvent) {
    const { message, filename, lineno, colno } = errorEvent;
    const { addErrorToReport, locale } = this.props;
    addErrorToReport(errorEvent, {
      message,
      filename,
      lineno,
      colno,
      collectionMethod: 'onerror',
      moduleID: 'axp-consumer-travel-root',
      componentName: 'ErrorReporter',
      stack: errorEvent?.error?.stack,
      locale,
    });
  }

  handleUnhandledRejection(error) {
    const { addErrorToReport, locale } = this.props;
    const { message, name, stack } = error.reason;
    addErrorToReport(error, {
      collectionMethod: 'unhandledrejection',
      moduleID: 'axp-consumer-travel-root',
      componentName: 'ErrorReporter',
      stack,
      name,
      message,
      locale,
    });
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

ErrorReporter.propTypes = {
  children: PropTypes.node,
  addErrorToReport: PropTypes.func.isRequired,
  locale: PropTypes.string,
};

ErrorReporter.defaultProps = {
  children: null,
  locale: undefined,
};

const mapStateToProps = (state) => ({
  locale: getLocaleData(state).locale,
});

const mapDispatchToProps = {
  addErrorToReport: addErrorReportThunk,
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorReporter);
